import { useState, useRef } from 'react';
import styled from 'styled-components';
import { useTheme } from '../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../Styles/theme';

export default function UnitInput(props) {
	const { className, placeholder, value, setValue, unit } = props;

	const { isDark } = useTheme();
	const theme = isDark ? darkTheme : lightTheme;

	const [changed, setChanged] = useState(false);
	const [changedPlaceholderColor, setChangedPlaceholderColor] = useState(false);
	const [clickCount, setClickCount] = useState(0);
	const [defaultPlaceholder, setDefaultPlaceholder] = useState(placeholder);

	const inputRef = useRef();

	function handleClick(e) {
		inputRef.current.style.borderColor = theme.primary;
	}

	function handleChange(e) {
    const regex = /[^0-9]/g;
    const result = e.target.value.replace(regex, "");

		if (result === '') setValue(0);
    else if (result < 9999999) setValue(parseInt(result).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','));

		setChanged(true);
	}

	function handleFocus(e) {
		setChangedPlaceholderColor(false);
		if (!changed) {
			setValue("");
		}
	}

	function handleBlur(e) {
		setClickCount(clickCount + 1);
		inputRef.current.style.borderColor = theme.line;
	}

	return (
    <TopLevelWrapper>
      <Input
        ref={inputRef}
        clickCount={clickCount}
        placeholder={defaultPlaceholder}
        value={value}
        changedColor={changedPlaceholderColor}
        onClick={handleClick}
        onChange={handleChange}
        onFocus={handleFocus}
        onBlur={handleBlur} />
        <Text>{unit}</Text>
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 5px;
`;

const Text = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 12px;

  color: ${props => props.theme.text};

  margin: 0 0 0 0;

	min-width: 11px;
`;

const Input = styled.input`
  text-align: right;
	font-family: NotoSansKR-Regular;
	font-size: 14px;
	line-height: 20px;

	padding: 0 8px 0 8px;

  width: 98px;
  height: 30px;

	outline: none;
  border: 1px solid ${props => props.theme.line};
  border-radius: 5px;
  background-color: ${props => props.theme.subBackground};

	color: ${props => props.theme.text};

	::placeholder {
		color: ${props => props.changedColor ? props.theme.pointRed : props.theme.gray};
	}

  transition: all 0.3s ease-in-out;
`;
